import { useMutation } from '@tanstack/react-query';
import {
  BidvH2HService,
  InquiryTransHistoryDto,
  TransHistoryH2hEntity,
} from 'services/openapi';

export const useBidvInquiryTransHistoryMutation = () =>
  useMutation<TransHistoryH2hEntity, Error, InquiryTransHistoryDto>({
    mutationFn: (variables) =>
      BidvH2HService.bidvH2HControllerInquiryTransHistory(variables),
    retry: 0,
  });
